import type {ReactElement} from 'react';
import React, { useEffect, useState} from 'react';
import type {ImageSlideListItem} from '@Components/contextual-menu/components/slideshow-list-item/slideshow-list-item.types';
import { SlideShowItemType} from '@Components/contextual-menu/components/slideshow-list-item/slideshow-list-item.types';
import {SlideshowListItem} from '@Components/contextual-menu/components/slideshow-list-item';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import {CircularProgressLoader, LOADER_COLOR, LOADER_SIZE} from '@Components/circular-progress-loader';
import styles from './image-slide-item.module.scss';

export function ImageSlideItem({className = '', isSelected = false, ...props}: Omit<ImageSlideListItem, 'type'>): ReactElement {
  const [imgSrc, setImgSrc] = useState('');
  const [hasImageSrcLoaded, setHasImageSrcLoaded] = useState(false);

  useEffect(() => {
    if (imgSrc !== '' || hasImageSrcLoaded) {
      return;
    }
    void props.getImgSrc().then((imageSource: string) => {
      setImgSrc(imageSource);
      setHasImageSrcLoaded(true);
    });
  }, []);

  const getImageSource = (): string => {
    if (hasImageSrcLoaded) {
      return imgSrc;
    }
    return '';
  };

  const getContainer = (): ReactElement => {
    return (
      <div className={`flex-center ${styles.mediaContainer} radius-4 `}>
        <Icon icon="icon-image" className={`color-extra-light ${styles.mediaContainerIcons}`} size={IconSize.SIZE_ICON_20} />
        {hasImageSrcLoaded ? (
          <img src={getImageSource()} alt={window.i18next.t('pmwjs_image')} className={`${styles.mediaSource} radius-4`} />
        ) : (
          <div className="flex-center">
            <CircularProgressLoader size={LOADER_SIZE.SMALL} color={LOADER_COLOR.PRIMARY} />
          </div>
        )}
      </div>
    );
  };

  return (
    <SlideshowListItem
      type={SlideShowItemType.IMAGE}
      onClick={(id: string): void => {
        props.onClick(id);
      }}
      onDelete={(id: string): void => {
        props.onDelete(id);
      }}
      element={getContainer()}
      id={props.id}
      index={props.index}
      className={className}
      isSelected={isSelected}
      duration={props.duration}
    />
  );
}
